import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./postHeader.html";
class PostHeader extends LightningElement {
  constructor(...args) {
    super(...args);
    this.url = void 0;
    this.title = void 0;
    this.date = void 0;
    this.readtime = void 0;
    this.contentType = void 0;
    this.shareTitle = void 0;
    this.copyTooltip = void 0;
    this.smallTitle = void 0;
    this.topTitle = void 0;
    this.displaySettings = void 0;
  }
  get displaySettingsObject() {
    return JSON.parse(this.displaySettings);
  }
  get displayTopTitle() {
    return this.topTitle && this.topTitle === 'true';
  }
  get titleClass() {
    return this.smallTitle && this.smallTitle === 'true' ? 'is-small-title' : '';
  }
  get displayTitle() {
    return this.displaySettingsObject?.title && this.title?.length;
  }
  get displayDate() {
    return this.displaySettingsObject?.date && this.date?.length;
  }
  get displayReadtime() {
    return this.displaySettingsObject?.readtime && this.readtime?.length;
  }
  get displayShare() {
    return this.displaySettingsObject?.share;
  }
  get displayContentType() {
    return this.displaySettingsObject?.type && this.contentType?.length;
  }
  get displayDateSeparator() {
    return this.displayDate && (this.displayReadtime || this.displayContentType);
  }
  get displayReadtimeSeparator() {
    return this.displayReadtime && this.displayContentType;
  }
  get displayMeta() {
    return this.displayDate || this.displayReadtime || this.displayContentType;
  }
  get postLink() {
    return this.url ? this.url : window.location.href;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(PostHeader, {
  publicProps: {
    url: {
      config: 0
    },
    title: {
      config: 0
    },
    date: {
      config: 0
    },
    readtime: {
      config: 0
    },
    contentType: {
      config: 0
    },
    shareTitle: {
      config: 0
    },
    copyTooltip: {
      config: 0
    },
    smallTitle: {
      config: 0
    },
    topTitle: {
      config: 0
    },
    displaySettings: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(PostHeader, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;